import { render } from "./MoreContent.vue?vue&type=template&id=09c25ace"
import script from "./MoreContent.vue?vue&type=script&lang=js"
export * from "./MoreContent.vue?vue&type=script&lang=js"

import "./MoreContent.vue?vue&type=style&index=0&id=09c25ace&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__